
const CACHE_PDF = '[cache][pdfs]cache.pdf';


export {CACHE_PDF}